var icon = require('vue-svgicon')
icon.register({
  'ks-icon-alert': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M68.45 75.14h-8.9V57.32h8.91m0 35.64h-8.91V84h8.91M15 106.32h98L64 21.68z"/>'
  }
})
